import { FC } from "react";
import { Box } from "@mui/material";
import { ExportDataItemDto } from "../../../../../../../api-client";
import { ExportDetails } from "./ExportDetails";
import { EdifactDisplay } from "./EdifactDisplay";

interface ExportDetailViewProps {
  exportItem: ExportDataItemDto;
}

export const ExportDetailView: FC<ExportDetailViewProps> = ({ exportItem }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        height: "100%",
        minHeight: 0,
      }}
    >
      {/* Left: Export Details */}
      <Box sx={{ flex: "0 0 350px", minWidth: 0 }}>
        <ExportDetails exportItem={exportItem} />
      </Box>

      {/* Right: EDIFACT Display */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <EdifactDisplay exportId={exportItem.id} />
      </Box>
    </Box>
  );
};
